module.exports = __webpack_public_path__ + "img/icons.fa967751.svg";